// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"a48a51fb","453":"d540cdf3","854":"f6c48a60"}[chunkId] + ".chunk.js";
};